"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetExhaustedHistoryMessageSchema = exports.EndOfBudgetPlanHistoryMessageSchema = exports.StartOfBudgetPlanHistoryMessageSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const budgets_web_1 = require("../../budgets-web");
const history_worker_1 = require("../../history-worker");
const StartOfBudgetPlanPayloadSchema = (0, core_1.StrictObject)(budgets_web_1.PlanResponseFields);
const EndOfBudgetPlanPayloadSchema = (0, core_1.StrictObject)(budgets_web_1.PlanResponseFields);
const BudgetExhaustedPayloadSchema = (0, core_1.StrictObject)({
    ...budgets_web_1.PlanResponseFields,
});
exports.StartOfBudgetPlanHistoryMessageSchema = (0, history_worker_1.createHistoryMessageSchema)(ruby_1.HistoryRecordType.BUDGETS_BUDGET_PLAN_STARTED, StartOfBudgetPlanPayloadSchema, {
    title: "Budget plan started history",
    description: "History message schema of message to be sent on the first day of a budget plan.",
});
exports.EndOfBudgetPlanHistoryMessageSchema = (0, history_worker_1.createHistoryMessageSchema)(ruby_1.HistoryRecordType.BUDGETS_BUDGET_PLAN_ENDED, EndOfBudgetPlanPayloadSchema, {
    title: "Budget plan ended history",
    description: "History message schema of message to be sent on the last day of a budget plan.",
});
exports.BudgetExhaustedHistoryMessageSchema = (0, history_worker_1.createHistoryMessageSchema)(ruby_1.HistoryRecordType.BUDGETS_BUDGET_PLAN_EXHAUSTED, BudgetExhaustedPayloadSchema, {
    title: "Budget exhausted history message",
    description: "History message schema of message to be sent when no more budget remains in a plan.",
});
